import { ImageWMS } from "ol/source";
import { Group, Image as ImageLayer } from "ol/layer";

const urlEstadistica = process.env.VITE_GEOSERVER_URL;

const cartografia_base2022 = [
  { title: "Localidades 2022", layer: "localidades_2022_1" },
  { title: "Envolventes 2022", layer: "envolventes_2022" },
];

const imageLayers2022 = cartografia_base2022.map(
  ({ title, layer }) =>
    new ImageLayer({
      title,
      visible: false,
      source: new ImageWMS({
        url: `${urlEstadistica}/limites/wms`,
        params: { LAYERS: layer, grupo: "limites" },
        serverType: "geoserver",
        crossOrigin: "Anonymous",
      }),
    })
);

// grupos

// catografia base
export const cartografiaBase = new Group({
  title: "Cartografía base",
  fold: "close",
  layers: imageLayers2022,
});
